import React,{useEffect,useState,useContext,Fragment} from 'react'
import SharedDataContext from '../../../../_helper/SharedData'
import { showAlert } from '../../../../Services/Shared.service'
import { Breadcrumbs } from '../../../../AbstractElements'
import { Row, Col, Card, CardBody, Container, } from 'reactstrap'
import { getPackageRatesListByPackId } from '../../../../Services/Packages.service'
import PackageRateInput from '../../../PackageRates/PackageRateInput'
import PackagesRateTable from '../../../PackageRates/PackagesRateTable'
import { CalendarViewFunctions } from '../../../PackageRates/Components/CalendarViewFunctions'
import PackageRateCalendar from '../../../PackageRates/PackageRateCalendar'
import CustomSelect from '../../../../CommonElements/CustomSelect'
// import * as React from "react";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Switch,
  styled,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import calendarIcon from "../../../../assets/images/tarrifManagement/calendarIcon.svg";
import tableIcon from "../../../../assets/images/tarrifManagement/tableIcon.svg";
import IconButtonCard from "../IconButtonCard";
import moment from "moment";
import RateInput from "../../../Rates/RateInput";
import EditPackageRateForm from "../../../FormsTariff/EditPackageRateForm";
import { useTariffSearch } from '../../../../_helper/TariffSearchContext/TariffSeachContext'
const calendarViewFunctions = new CalendarViewFunctions()

function PackageRatesTable({ packId, selectedPackage }) {
  const {cityData, globalCityField, setShowApiLoader} = useContext(SharedDataContext);
  const {packageRateInputModal,packageRateCreated,setPackageRateCreated} = useTariffSearch();
  const [loader, setLoader] = useState(false);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);
    const [isOpen, setIsOpen] = useState(false)
  // const [editId, setEditId] = useState("");
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 30,
    });
    const [tableData, setTableData] = useState([]);
    const [isToggled, setIsToggled] = useState(false)
    const [calendarData, setCalendarData] = useState([])
    const [tableHeaders, setTableHeaders] = useState([])
    const [packagesData, setPackagesData] = useState([])
  // const [selectedPackage, setSelectedPackage] = useState({});
  const [isEditRate, setIsEditRate] = useState({
    drawerState: false,
    selectedRateId: "",
  });

    const onChangePage = (page) => {
    //   console.log("page", page);
      setPagination({
          ...pagination,
          pageIndex: page - 1
      });
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
      setPagination({
          ...pagination,
          pageSize: currentRowsPerPage
      });
  };

  const onPackageNameClicked = (packageDetails) => {
    // setSelectedPackage(packageDetails);
    setIsOpen(true);
  };

  useEffect(() => {
      fetchTableData();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
  if(!packageRateInputModal && packageRateCreated){
    fetchTableData();
    setPackageRateCreated(false); // Reset the flag after fetching
  }
  }, [packageRateInputModal, packageRateCreated]);

  const fetchTableData = () => {
        // const serviceCityId = globalCityField.value?.id || '0';
        let obj = {
          packId: packId,
          page: pagination.pageIndex,
          size: pagination.pageSize,
        };

        setLoader(true);
        getPackageRatesListByPackId(obj)
            .then(async (result) => {
                console.log("packageRate List from table is ",result.data)
                setPaginationTotalRows(result.data.count);
                setTableData(result.data.searchResponse);
                setCalendarData(await calendarViewFunctions.getCalendarData(result.data.searchResponse, onEditClick, onPackageNameClicked))
                setTableHeaders(await calendarViewFunctions.getTableHeaderWithHours())
                disableLoaders();
            })
            .catch((err) => {
                console.log("err", err)
                disableLoaders();
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
   };

   const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
};

const onEditClick = (obj) => {
    setIsOpen(true)
    // setEditId(obj.id);
};

useEffect(() => {
    if (searchData && filterType != "search") {
        fetchTableData()
        return;
    }
    setPagination({
        pageIndex: 0,
        pageSize: 30,
    })
    // fetchTableData()
}, [searchData]);

const toggleModal = () => {
    fetchTableData()
    // setEditId("");
    setIsOpen(!isOpen)
};

const toggleBar = () => {
    setIsToggled(!isToggled)
    setSearchData("")
    setFilterType("")
    setPagination({
        pageIndex: 0,
        pageSize: 30,
    });
  };

  const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",

    // CHECKED STATE
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "rgba(57, 181, 74, 1)",
        opacity: 1,
        border: 0,
      },
    },

    // CHECKED + DISABLED → KEEP SAME COLOR, NO DIMMING
    "&.Mui-checked.Mui-disabled": {
      transform: "translateX(16px)",
      color: "grey",
    },
    "&.Mui-checked.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: "rgba(57, 181, 74, 1) !important",
      opacity: "1 !important",   // 🔥 No dimming
    },

    // THUMB color on disabled
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "#fff",
    },
  },

  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },

  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#A9A9A9",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
  const convertSecondsToTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);

  return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
};


  function Row({ row, onEdit }) {
    const [open, setOpen] = React.useState(false);

    return (
      <>
        <TableRow>
          {/* Expand / Collapse Arrow */}
          <TableCell>
            <IconButton size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>

          <TableCell
            sx={{
              textAlign: "center",
              fontSize: "1.11vw",
              color: "#39B54A",
              fontWeight: "600",
              padding: "0.83vw",
            }}
          >
            {row.packageValue}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              fontSize: "1.11vw",
              fontWeight: "400",
              padding: "0.83vw",
            }}
          >
            {row.addnlPerKmCharge ?? "-"}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              fontSize: "1.11vw",
              fontWeight: "400",
              padding: "0.83vw",
            }}
          >
            {row.pkgDistance}
          </TableCell>
          {/* <TableCell
            align="center"
            sx={{
              fontSize: "1.11vw",
              fontWeight: "400",
              padding: "0.83vw",
            }}
          >
            {row.packageHours ?? "-"}
          </TableCell> */}
          <TableCell
            align="center"
            sx={{
              fontSize: "1.11vw",
              color: "#39B54A",
              fontWeight: "400",
              padding: "0.83vw",
            }}
          >
            {row.packageRideType}
          </TableCell>
          {/* <TableCell
            align="center"
          >
            <Box sx={{ display: 'flex', justifyContent: 'center'}}>
              {row.isInclusive ? (
                <Box
                  sx={{
                    display: "flex",
                    backgroundColor: "#E3F5E1",
                    width: "6.11vw",
                    height: "2.01vw",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    alignSelf: "center",
                    borderRadius: "6px",
                    padding: "6px",
                    border: "1px solid rgba(116, 206, 106, 1)",
                  }}
                >
                  <Box
                    sx={{
                      width: "0.56vw",
                      height: "0.56vw",
                      background: "rgba(116, 206, 106, 1)",
                      borderRadius: "50%",
                    }}
                  />
                  <Typography sx={{ fontSize: "0.97vw" }}>Yes</Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    width: "6.11vw",
                    height: "2.01vw",
                    borderRadius: "6px",
                    padding: "6px",
                    backgroundColor: "#ffe5e5", // light red
                    border: "1px solid #cc0000", // darker red border
                  }}
                >
                  <Box
                    sx={{
                      width: "0.56vw",
                      height: "0.56vw",
                      backgroundColor: "#cc0000",
                      borderRadius: "50%",
                    }}
                  />
                  <Typography sx={{ fontSize: "0.97vw", color: "#cc0000" }}>
                    No
                  </Typography>
                </Box>
              )}
            </Box>
          </TableCell> */}
          <TableCell
            align="center"
            sx={{
              fontSize: "1.11vw",
              fontWeight: "400",
              padding: "0.83vw",
            }}
          >
            <Box
              sx={{
                flex: 1,
                fontSize: "1vw",
                color: "#313131",
                fontWeight: "bold",
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              {row.isTimeBased ? (
                <Box
                  sx={{
                    display: "flex",
                    backgroundColor: "#E3F5E1",
                    width: "6.11vw",
                    height: "2.01vw",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    borderRadius: "6px",
                    padding: "6px",
                    border: "1px solid rgba(116, 206, 106, 1)",
                  }}
                >
                  <Box
                    sx={{
                      width: "0.56vw",
                      height: "0.56vw",
                      background: "rgba(116, 206, 106, 1)",
                      borderRadius: "50%",
                    }}
                  />
                  <Typography sx={{ fontSize: "0.97vw" }}>Yes</Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    width: "6.11vw",
                    height: "2.01vw",
                    borderRadius: "6px",
                    padding: "6px",
                    backgroundColor: "#ffe5e5", // light red
                    border: "1px solid #cc0000", // darker red border
                  }}
                >
                  <Box
                    sx={{
                      width: "0.56vw",
                      height: "0.56vw",
                      backgroundColor: "#cc0000",
                      borderRadius: "50%",
                    }}
                  />
                  <Typography sx={{ fontSize: "0.97vw", color: "#cc0000" }}>
                    No
                  </Typography>
                </Box>
              )}
              </Box>
            </Box>
          </TableCell>
          <TableCell align="center">
            <IconButton onClick={() => onEdit(row)}>
              <EditIcon />
            </IconButton>
          </TableCell>
        </TableRow>

        {/* Collapsible Section */}
        <TableRow>
          <TableCell colSpan={8} sx={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={open} unmountOnExit>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  marginY: "1.11vw",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <Typography sx={{ fontWeight: "0.97vw" }}>
                      Applicable From
                    </Typography>
                    <Typography sx={{ fontWeight: "500" }}>
                      {convertSecondsToTime(row.timeFrom)}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <Typography sx={{ fontWeight: "0.97vw" }}>
                      Applicable To
                    </Typography>
                    <Typography sx={{ fontWeight: "500" }}>
                      {convertSecondsToTime(row.timeTo)}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <Typography sx={{ fontWeight: "0.97vw" }}>
                      Minimum Distance
                    </Typography>
                    <Typography sx={{ fontWeight: "500" }}>
                      {row.minPkgDistance}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <Typography sx={{ fontWeight: "0.97vw" }}>
                      Maximum Distance
                    </Typography>
                    <Typography sx={{ fontWeight: "500" }}>
                      {row.maxPkgDistance}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }
  //   const rows = [
  //     {
  //       packageAmount: "₹1000",
  //       perKmCharge: "₹12",
  //       packageDistance: "50 KM",
  //       packageHours: "6 Hrs",
  //       rideType: "Local",
  //       taxInclusive: true,
  //       applicableFrom: "01/01/2025",
  //       applicableTo: "31/12/2025",
  //       extraTimeBlock: "30 Mins",
  //       extraTimeCharge: "₹150",
  //       minDistance: "0 KM",
  //       maxDistance: "200 KM",
  //     },
  //   ];
  const handleEdit = (row) => {
    setIsEditRate((prev) => ({
      ...prev,
      drawerState: true,
      selectedRateId: row.id,
    }));
  };


  const handleRateDrawer = (state) => {
    setIsEditRate((prev) => ({
      ...prev,
      drawerState: state,
      selectedRateId: state ? prev.selectedRateId : "",
    }));
  };
  return (
    <>
      <Box sx={{ marginTop: "10px" }}>
        {tableData.length == 0 ? (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "white",
              minHeight: "200px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "6px",
            }}
          >
            <Typography sx={{ color: "black" }}>No Rates Available</Typography>
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "2vw",
              }}
            >
              <Typography sx={{ fontSize: "1.39vw", fontWeight: "600" }}>
                Package Rates
              </Typography>
              {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "29%",
                }}
              >
                <IconButtonCard
                  icon={calendarIcon}
                  label="Calendar View"
                  backgroundColor="rgba(255, 255, 255, 1)"
                  borderColor="rgba(217, 217, 217, 1)"
                  fontColor="black"
                  onClick={() => console.log("clicked")}
                />
                <IconButtonCard
                  icon={tableIcon}
                  label="Table View"
                  backgroundColor="rgba(225, 244, 228, 1)"
                  borderColor="rgba(57, 181, 74, 1)"
                  fontColor="rgba(57, 181, 74, 1)"
                  onClick={() => console.log("clicked")}
                />
              </Box> */}
            </Box>
            <Box sx={{ marginTop: "2vw" }}>
              <TableContainer
                component={Paper}
                aria-label="sticky table"
                sx={{
                  maxHeight: "22vw",
                  overflowY: "auto",
                  scrollbarWidth: "none", // Firefox
                  "&::-webkit-scrollbar": {
                    display: "none", // Chrome, Safari, Edge
                  },
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          color: "#626262",
                          fontWeight: "bold",
                          fontSize: "1.11vw",
                          height: "3.89vw",
                          maxHeight: "5vw",
                          paddingX: 0,
                          paddingY: "12px",
                          backgroundColor: "#E1F4E4",
                        },
                      }}
                    >
                      <TableCell />
                      <TableCell align="center">Package Fee</TableCell>
                      <TableCell align="center">Per Km Charge</TableCell>
                      <TableCell align="center">Maximum Distance</TableCell>
                      {/* <TableCell align="right">Package Hours</TableCell> */}
                      <TableCell align="center">Ride Type</TableCell>
                      {/* <TableCell align="center">Tax Inclusive</TableCell> */}
                      <TableCell align="center">Time based</TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {tableData.map((singleRateObj, index) => (
                      <Row
                        key={index}
                        row={singleRateObj}
                        onEdit={handleEdit}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </>
        )}
      </Box>

      <EditPackageRateForm
        isOpen={isEditRate.drawerState}
        setIsOpen={handleRateDrawer}
        editId={isEditRate.selectedRateId}
        selectedPackage={selectedPackage}
        fetchTableData={fetchTableData}
      />
    </>
  );
}

export default PackageRatesTable